import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorModalContent } from './PopUpErrorModal.styles';
import { Modal } from '../Modal/Modal';
import { Text } from '../Text/Text';
import { LoadingSpinner } from '../LoadingSpinner';

const ErrorLaptopImg = React.lazy(() => import('shared/components/icons/ErrorLaptopImg'));

type Props = {
  openModal: boolean;
  onRefresh: () => void;
  onCloseModal: () => void;
};
export function PopUpErrorModal({ openModal, onCloseModal, onRefresh }: Props) {
  const { t } = useTranslation();
  const ctaButtons = {
    primary: {
      label: t('cta.tryAgain'),
      onClick: onRefresh,
    },
  };
  return (
    <Modal
      contentLabel={t('error.downloadContract.header')}
      isOpen={openModal}
      subHeader
      styleVariant="tertiary"
      ctaButtons={ctaButtons}
      onRequestClose={onCloseModal}
    >
      <ErrorModalContent>
        <Suspense fallback={<LoadingSpinner />}>
          <ErrorLaptopImg />
        </Suspense>
        <Text as="h2">{t('error.downloadContract.header')}</Text>
        <Text as="p">{t('error.downloadContract.description')}</Text>
      </ErrorModalContent>
    </Modal>
  );
}

export default PopUpErrorModal;
